import { render, staticRenderFns } from "./usercollect-add-or-update.vue?vue&type=template&id=91bbbb9c"
import script from "./usercollect-add-or-update.vue?vue&type=script&lang=js"
export * from "./usercollect-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports